// dataReducer.js
import {
  COLLABORATOR__FETCH_DATA_FAILURE,
  COLLABORATOR__FETCH_DATA_REQUEST,
  COLLABORATOR__FETCH_DATA_SUCCESS,
} from "../actions/types/collaboratorAction.types";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case COLLABORATOR__FETCH_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case COLLABORATOR__FETCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: "",
      };
    case COLLABORATOR__FETCH_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
